import { render, staticRenderFns } from "./CommentTextBox.vue?vue&type=template&id=008ab1a0&scoped=true&"
import script from "./CommentTextBox.vue?vue&type=script&lang=ts&"
export * from "./CommentTextBox.vue?vue&type=script&lang=ts&"
import style0 from "./CommentTextBox.vue?vue&type=style&index=0&id=008ab1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008ab1a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFileInput,VTextField})
